import React, { useEffect, useState } from 'react'
import { useAuth, useNotifications, useAnalytics } from 'hooks'
import datePeriods from 'shared/datasets/date-periods'
import useReportCreate from '../hooks/useReportCreate'
import useRunReportWithIntegration from '../hooks/useRunReportWithIntegration'
import TemplateStep from '../templates/TemplateStep'
import IntegrationSubmitStep from './IntegrationSubmitStep'

const DEFAULT_REPORT_PERIOD = datePeriods().find((p) => p.value === 'last-year')

export default function IntegrationReport({
  modal,
  onBack,
  step,
  onNext,
  integration,
  currentTemplate,
  handleTemplateChange,
  configSections,
  setConfigSections,
  editing,
  defaultReportSections,
  defaultTemplate,
  organization,
}) {
  const { currentCompany } = useAuth()
  const [submitting, setSubmitting] = useState(false)
  const [valid, setValid] = useState(false)
  const [reportPeriod, setReportPeriod] = useState(DEFAULT_REPORT_PERIOD)
  const [reportName, setReportName] = useState('')
  const notifications = useNotifications()
  const [createReport] = useReportCreate()
  const [runReportWithIntegration] = useRunReportWithIntegration()
  const analytics = useAnalytics()

  useEffect(() => {
    setValid(reportPeriod?.interval)
  }, [reportPeriod])

  const handleCreate = async () => {
    setSubmitting(true)

    const { report } = await createReport({
      companyId: currentCompany.id,
      kind: 'anomaly:1',
      name: reportName,
      periodStart: reportPeriod.interval.start.toISODate(),
      periodEnd: reportPeriod.interval.end.toISODate(),
      config: { sections: configSections },
    })

    // call the runReportWithIntegration lambda, but don't wait for it since
    // we'll get updates via report subscription
    runReportWithIntegration({
      reportId: report.id,
      integrationId: integration.id,
    })

    analytics.track('Report Created', { reportId: report.rowId })
    notifications.info('Report created.')
    modal.onClose({ force: true })
  }

  const steps = [TemplateStep, IntegrationSubmitStep]
  const StepComponent = steps[step - 1]

  return (
    <StepComponent
      currentTemplate={currentTemplate}
      handleTemplateChange={handleTemplateChange}
      configSections={configSections}
      setConfigSections={setConfigSections}
      onClose={modal.onClose}
      onBack={onBack}
      onNext={onNext}
      submitting={submitting}
      reportPeriod={reportPeriod}
      setReportPeriod={setReportPeriod}
      reportName={reportName}
      setReportName={setReportName}
      valid={valid}
      handleCreate={handleCreate}
      editing={editing}
      closeAllOtherModals={modal.closeAllOtherModals}
      defaultReportSections={defaultReportSections}
      defaultTemplate={defaultTemplate}
      organization={organization}
    />
  )
}
